// Copyright (c) 2025 Audere, All Rights Reserved

import { AppBar, Box, CssBaseline } from "@mui/material";
import { Outlet, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useEffect } from "react";

import {
  resetIsLoggedOut,
  selectCurrentToken,
  selectIsLoggedOut,
} from "../features/auth/authSlice";
import { createStyleSheet } from "../utils/styles";
import UserProfile from "./UserProfile";
import AppLogo from "../../assets/HP_Logo.svg";
import AppLoader from "./AppLoader";
import { useAppDispatch } from "../features/store";

const PrimaryAppBar = () => {
  const isLoggedIn = !!useSelector(selectCurrentToken);
  const isLoggedOut = useSelector(selectIsLoggedOut);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isLoggedOut) {
      dispatch(resetIsLoggedOut());
    }
  }, [isLoggedOut, navigate, dispatch]);

  return (
    <Box sx={styles.container}>
      <CssBaseline />
      <AppBar position="static" color="transparent" sx={styles.appBar}>
        <Box sx={styles.headerContainer}>
          <img
            src={AppLogo}
            alt="HealthPulse AI"
            style={{ height: "40px", objectFit: "contain" }}
          />
          {isLoggedIn && <UserProfile />}
        </Box>
      </AppBar>
      <Box sx={styles.outletContainer} data-testid="outlet-container">
        <Outlet />
      </Box>
      {isLoggedIn && <AppLoader />}
    </Box>
  );
};

const styles = createStyleSheet({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
  appBar: {
    boxShadow: 0,
    borderBottom: 1,
    borderBottomColor: "grey.300",
  },
  headerContainer: {
    height: "100px",
    px: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  outletContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "calc(100% - 100px)",
    overflowY: "auto",
  },
});

export default PrimaryAppBar;
